// extracted by mini-css-extract-plugin
export default {"dropMenuWrapper":"DropMenu_dropMenuWrapper__H5SYG","dropMenuSection":"DropMenu_dropMenuSection__PFoJ7"};